let turnstileScriptPromise = null;
let widgetId = null;

const TURNSTILE_SCRIPT_URL =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

function loadTurnstileScript() {
  if (window.turnstile) {
    return Promise.resolve();
  }
  if (turnstileScriptPromise) {
    return turnstileScriptPromise;
  }

  turnstileScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src^="${TURNSTILE_SCRIPT_URL}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.src = TURNSTILE_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return turnstileScriptPromise;
}

function getOrCreateContainer() {
  let container = document.getElementById("turnstile-widget-container");
  if (!container) {
    container = document.createElement("div");
    container.id = "turnstile-widget-container";
    container.style.display = "none";
    document.body.appendChild(container);
  }
  return container;
}

export async function executeTurnstile(siteKey) {
  if (!siteKey) {
    return null;
  }

  await loadTurnstileScript();

  const container = getOrCreateContainer();

  return new Promise((resolve, reject) => {
    const resetWidget = () => {
      if (widgetId !== null && window.turnstile) {
        try {
          window.turnstile.remove(widgetId);
        } catch (e) {
          // ignore
        }
        widgetId = null;
      }
    };

    resetWidget();

    widgetId = window.turnstile.render(container, {
      sitekey: siteKey,
      size: "invisible",
      callback: (token) => {
        resolve(token);
        resetWidget();
      },
      "error-callback": () => {
        resetWidget();
        reject(new Error("Turnstile doğrulaması başarısız."));
      },
      "timeout-callback": () => {
        resetWidget();
        reject(new Error("Turnstile doğrulama zaman aşımına uğradı."));
      },
    });

    window.turnstile.execute(widgetId);
  });
}
